import { Page, Content, InfoCard } from '@backstage/core-components';
import { ClientDataTable } from '@WESCO-International/wdp-ui-components/components/table';
import { Input } from '@WESCO-International/wdp-ui-components/components/input';
import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaSearch } from 'react-icons/fa';
import { domainOptions } from '../common/utils';

export const DomainPage = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');

  const rows = useMemo(
    () =>
      domainOptions.map(opt => ({
        domain: opt.label,
        owner: opt.owner ?? 'guest',
        description: opt.description ?? '-',
        value: opt.value,
      })),
    [],
  );

  const filteredRows = useMemo(() => {
    const term = searchTerm.trim().toLowerCase();
    if (!term) return rows;
    return rows.filter(r => {
      return (
        String(r.domain ?? '')
          .toLowerCase()
          .includes(term) ||
        String(r.owner ?? '')
          .toLowerCase()
          .includes(term) ||
        String(r.description ?? '')
          .toLowerCase()
          .includes(term)
      );
    });
  }, [rows, searchTerm]);

  const columns = [
    {
      key: 'domain',
      name: 'Domain',
      formatter: ({ row }: { row: any }) => (
        <a
          href="#"
          className="link"
          onClick={e => {
            e.preventDefault();
            navigate(`/domains/${encodeURIComponent(row.value)}`);
          }}
        >
          {row.domain}
        </a>
      ),
      width: 180,
    },
    { key: 'owner', name: 'Owner', width: 140 },
    { key: 'description', name: 'Description' },
  ];

  return (
    <Page themeId="home">
      <Content>
        <div className="pageHeader">
          <h5 className="wdp-heading s-5 semibold headingLarge">Domain</h5>
        </div>
        <InfoCard
          className="domainCard"
          title={
            <div className="cardTitleRow">
              <span className="cardTitleSmall">
                Domain ({filteredRows.length})
              </span>
              <div className="cardTitleSearchContainer">
                <Input
                  placeholder="Search"
                  value={searchTerm}
                  onChange={(e: any) => setSearchTerm(e.target.value)}
                  iconLeft={<FaSearch />}
                />
              </div>
            </div>
          }
        >
          <ClientDataTable
            columns={columns}
            rows={filteredRows}
            paginate
            resize={true}
            dense={false}
            rowHeight={42}
            headerRowHeight={42}
            verticalBorder={false}
          />
        </InfoCard>
      </Content>
    </Page>
  );
};
